import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'm17 17 5 5', key: 'p7ous7' }],
  ['path', { d: 'M19.323 13.744A9 3 0 0 0 21 12', key: 'hmry77' }],
  ['path', { d: 'M21 13.127V5', key: '59o5vz' }],
  ['path', { d: 'm22 17-5 5', key: 'gqnmv0' }],
  ['path', { d: 'M3 12A9 3 0 0 0 13.563 14.954', key: '1rmyhq' }],
  ['path', { d: 'M3 5V19A9 3 0 0 0 13 21.981', key: '159k2m' }],
  ['ellipse', { cx: '12', cy: '5', rx: '9', ry: '3', key: 'msslwz' }],
];

/**
 * @component @name DatabaseX
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTcgMTcgNSA1IiAvPgogIDxwYXRoIGQ9Ik0xOS4zMjMgMTMuNzQ0QTkgMyAwIDAgMCAyMSAxMiIgLz4KICA8cGF0aCBkPSJNMjEgMTMuMTI3VjUiIC8+CiAgPHBhdGggZD0ibTIyIDE3LTUgNSIgLz4KICA8cGF0aCBkPSJNMyAxMkE5IDMgMCAwIDAgMTMuNTYzIDE0Ljk1NCIgLz4KICA8cGF0aCBkPSJNMyA1VjE5QTkgMyAwIDAgMCAxMyAyMS45ODEiIC8+CiAgPGVsbGlwc2UgY3g9IjEyIiBjeT0iNSIgcng9IjkiIHJ5PSIzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/database-x
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const DatabaseX = createLucideIcon('database-x', __iconNode);

export default DatabaseX;
